export const DEFAULT_AUTOMATION_VALUES = {
  status: "Disabled",
  priority: "Low",
  settings: {
    Retries: "0",
    Timeout: "30",
  },
  metrics: {
    Executions: 0,
    Successes: 0,
    Failures: 0,
  },
};

export const transformFormToApiPayload = (formData, brandId, userId) => {
  console.log(formData);

  return {
    BrandId: parseInt(brandId),
    UserId: parseInt(userId),
    Name: formData.name,
    Description: formData.description,
    Priority: formData.priority || DEFAULT_AUTOMATION_VALUES.priority,
    Status: formData.status || DEFAULT_AUTOMATION_VALUES.status,
    Schedule: JSON.stringify({
      Start: new Date(formData.schedule.start).toISOString(),
      End: new Date(formData.schedule.end).toISOString(),
      LastRun: new Date(formData.schedule.start).toISOString(),
      NextRun: new Date(
        formData.schedule.NextRun || formData.schedule.start
      ).toISOString(),
    }),
    Metrics: JSON.stringify(
      formData.metrics || DEFAULT_AUTOMATION_VALUES.metrics
    ),
    Audiences: JSON.stringify(formData.audiences || []),
    Settings: JSON.stringify({
      Retries: parseInt(
        formData.settings?.Retries || DEFAULT_AUTOMATION_VALUES.settings.Retries
      ),
      Timeout: parseInt(
        formData.settings?.Timeout || DEFAULT_AUTOMATION_VALUES.settings.Timeout
      ),
    }),
  };
};

export const getInitialFormState = () => ({
  name: "",
  description: "",
  status: DEFAULT_AUTOMATION_VALUES.status,
  priority: DEFAULT_AUTOMATION_VALUES.priority,
  schedule: {
    Start: "",
    End: "",
    NextRun: "",
  },
  settings: DEFAULT_AUTOMATION_VALUES.settings,
  metrics: DEFAULT_AUTOMATION_VALUES.metrics,
  audiences: [],
  actions: {
    Id: 0,
    Type: "",
    To: "",
    Subject: "",
    Body: "",
    Attachments: "",
  },
});
